import { RadioGroup } from '@zoopla-eng/zds-components/radio-group';
import { queries } from '@zoopla-eng/zds-components/themes';
import { useBreakpointListener } from '@zoopla/dom-util';

export type Added =
    | ''
    | '24_hours'
    | '3_days'
    | '7_days'
    | '14_days'
    | '30_days';

type AddedToSiteProps = {
    value: Added;
    onChange: (added: Added) => void;
};

export const AddedToSite = ({ value, onChange }: AddedToSiteProps) => {
    const bisect = useBreakpointListener(queries.M[100], 'GT');

    return (
        <RadioGroup
            bisect={bisect}
            label="Added"
            value={value}
            items={[
                {
                    id: 'added_anytime',
                    value: '',
                    label: 'Added anytime'
                },
                {
                    id: 'added_24_hours',
                    value: '24_hours',
                    label: 'Last 24 hours',
                    helpText: ''
                },
                {
                    id: 'added_3_days',
                    value: '3_days',
                    label: 'Last 3 days',
                    helpText: ''
                },
                {
                    id: 'added_7_days',
                    value: '7_days',
                    label: 'Last 7 days',
                    helpText: ''
                },
                {
                    id: 'added_14_days',
                    value: '14_days',
                    label: 'Last 14 days',
                    helpText: ''
                },
                {
                    id: 'added_30_days',
                    value: '30_days',
                    label: 'Last 30 days',
                    helpText: ''
                }
            ]}
            onValueChange={onChange}
        />
    );
};
